import { DailyInfoResponse } from '../Domain/Interfaces/DailyInfoResponse';

export const GetHistoricalData = async (
  symbol: string,
  dateFrom: string,
  dateTo: string,
): Promise<DailyInfoResponse> => {
  const apiKey = process.env.REACT_APP_STOCK_API_KEY;
  const error = new Error('Something went wrong');

  const data: Response = await fetch(
    `https://eodhistoricaldata.com/api/eod/${symbol}?from=${dateFrom}&to=${dateTo}&api_token=${apiKey}&order=d&fmt=json`,
  );
  if (data.status == 200) {
    return await EodResponseToDailyInfo(data, symbol);
  } else {
    throw error;
  }
};

const EodResponseToDailyInfo = async (response: Response, symbol: string) => {
  const data = await response.json();

  const stockData = data.map((r: any) => ({
    volume: r.volume,
    open: r.open,
    close: r.close,
    low: r.low,
    high: r.high,
    symbol: symbol,
    date: new Date(r.date),
  }));

  return { data: stockData };
};
